import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUp, Send } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
    const [email, setEmail] = useState("");

    const subscribe = (e) => {
        e.preventDefault();
        if (!email.includes("@")) {
            toast.error("Entre une adresse email valide.");
            return;
        }
        toast.success("Bienvenue dans la famille ! Les offres arrivent.");
        setEmail("");
    };

    return (
        <footer
            data-testid="footer-container"
            className="relative overflow-hidden border-t border-white/10 bg-[#080808]"
        >
            <div className="pointer-events-none absolute -bottom-24 left-1/2 h-[280px] w-[620px] -translate-x-1/2 rounded-full bg-rose-600/15 blur-[130px]" />

            <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
                <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <a href="#hero" className="flex items-center gap-3">
                            <img
                                src="/assets/logo.png"
                                alt="Petit Veau Athis-Mons"
                                className="h-14 w-14 object-contain drop-shadow-[0_0_14px_rgba(185,28,28,0.35)]"
                            />
                            <span className="flex flex-col leading-none">
                                <span className="font-display text-xl font-black uppercase tracking-tight">
                                    Petit Veau
                                </span>
                                <span className="font-script text-base text-rose-500">
                                    Athis-Mons
                                </span>
                            </span>
                        </a>
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-500">
                            Sandwichs, assiettes, fantastiques et burgers cuits à la braise.
                            Le goût du feu de bois, au cœur d'Athis-Mons — du lundi au samedi.
                        </p>
                        <form onSubmit={subscribe} className="mt-8 flex max-w-md gap-3">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="footer-newsletter-input"
                                placeholder="Ton email pour les offres secrètes"
                                className="font-mono2 w-full rounded-full border border-white/15 bg-white/5 px-5 py-3 text-xs tracking-wider text-zinc-200 placeholder:text-zinc-600 focus:border-rose-500/60 focus:outline-none"
                            />
                            <motion.button
                                type="submit"
                                data-testid="footer-newsletter-submit"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-rose-600 text-white transition-colors hover:bg-rose-500"
                                aria-label="S'inscrire"
                            >
                                <Send className="h-4 w-4" />
                            </motion.button>
                        </form>
                    </div>

                    <div className="grid grid-cols-2 gap-10 lg:col-span-6 lg:pl-16">
                        <div>
                            <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                Naviguer
                            </p>
                            <ul className="mt-5 flex flex-col gap-3 text-sm text-zinc-400">
                                <li><a href="#menu" className="transition-colors hover:text-rose-400">Menu & Tarifs</a></li>
                                <li><a href="#manifesto" className="transition-colors hover:text-rose-400">L'Histoire</a></li>
                                <li><a href="#location" className="transition-colors hover:text-rose-400">Notre Adresse</a></li>
                                <li><a href="#socials" className="transition-colors hover:text-rose-400">Nos Réseaux</a></li>
                            </ul>
                        </div>
                        <div>
                            <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                Contact
                            </p>
                            <ul className="mt-5 flex flex-col gap-3 text-sm text-zinc-400">
                                <li>180 Av. François Mitterrand</li>
                                <li>91200 Athis-Mons, France</li>
                                <li>
                                    <a href="tel:+33661970727" className="transition-colors hover:text-rose-400">
                                        06 61 97 07 27
                                    </a>
                                </li>
                                <li>Lun–Sam : 11h30 — 22h30</li>
                                <li>Dimanche : Fermé</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div
                    className="text-stroke font-display pointer-events-none mt-16 select-none text-center text-[13vw] font-black uppercase leading-none lg:text-[11rem]"
                    aria-hidden
                >
                    PETIT VEAU
                </div>

                <div className="mt-10 flex flex-col items-center justify-between gap-5 border-t border-white/10 pt-8 sm:flex-row">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-600">
                        © 2026 Petit Veau Athis-Mons — Cuit à la braise
                    </p>
                    <div className="flex items-center gap-6">
                        <a href="#hero" className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-600 transition-colors hover:text-rose-400">
                            Mentions Légales
                        </a>
                        <motion.a
                            href="#hero"
                            data-testid="footer-back-to-top"
                            whileHover={{ scale: 1.1, y: -2 }}
                            whileTap={{ scale: 0.95 }}
                            className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-zinc-300 transition-colors hover:border-rose-500/60 hover:text-rose-400"
                            aria-label="Retour en haut"
                        >
                            <ArrowUp className="h-4 w-4" />
                        </motion.a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
